import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarClock, Plus } from 'lucide-react';
import { portalApi } from './portalApi';
import { Card, Empty, PageHeader, Spinner, Tabs } from './portalUi';
import { DispatchRow } from './PortalOverview';

const monthKey = (d) => new Date(`${d}T12:00:00`).toLocaleDateString('en-CA', { month: 'long', year: 'numeric' });

export default function PortalSchedule() {
  const [data, setData] = useState(null);
  const [tab, setTab] = useState('upcoming');
  useEffect(() => { portalApi.get('/schedule').then((r) => setData(r.data)); }, []);
  if (!data) return <Spinner />;
  const rows = tab === 'past' ? [...data.past].reverse() : data[tab];
  const groups = rows.reduce((acc, d) => { const k = monthKey(d.start_date); (acc[k] = acc[k] || []).push(d); return acc; }, {});

  return (
    <div data-testid="portal-schedule">
      <PageHeader overline="Dispatches & schedule" title="Crew on the board for you"
        subtitle="Confirmed dispatches are locked in with the crew; tentative ones are pencilled in and can still move. Names update as dispatch confirms replies."
        actions={<Link className="p-btn p-btn-primary" to="/portal/request" data-testid="schedule-request-btn"><Plus className="w-4 h-4" /> Request crew</Link>} />
      <div className="mb-5"><Tabs testPrefix="schedule-tab" value={tab} onChange={setTab} tabs={[
        { key: 'upcoming', label: 'Upcoming', count: data.upcoming.length },
        { key: 'past', label: 'Past 60 days', count: data.past.length },
        { key: 'cancelled', label: 'Cancelled', count: data.cancelled.length }]} /></div>
      {rows.length === 0 ? <Card><Empty icon={CalendarClock} title={tab === 'upcoming' ? 'Nothing scheduled yet' : 'Nothing here'} text={tab === 'upcoming' ? 'Send a service request and dispatch will put crew on the board.' : undefined} /></Card>
        : Object.entries(groups).map(([m, list]) => (
          <div key={m} className="mb-6 p-rise">
            <div className="p-overline mb-2">{m}</div>
            <Card className="px-5 py-1">{list.map((d) => <DispatchRow key={d.id} d={d} testId={`schedule-row-${d.id}`} />)}</Card>
          </div>))}
    </div>
  );
}
